import React, { useContext, useEffect, useState } from "react";
import CustomButton from "../CustomButton";
import RichTextEditor from "../texts/RichTextEditor";
import { OrganizationContext } from "../../contexts/OrganizationContextProvider";
import { createLesson, getTasks } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import { useFormik } from "formik";
import ModalUI from "../ui/ModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import CustomSelectBox from "../Inputs/CustomSelectBox"; 
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import CustomTemplateDropdown from "../Inputs/CustomTemplateDropdown";
import AddUpdateLessonTemplateModal from "./AddUpdateLessonTemplateModal";
import SelectLessonTemplateModal from "./SelectLessonTemplateModal";
import {lessonValidationSchema} from "../../utils/validations"


function AddNewLesson({ show, onAddLesson, handleClose, taskId,workStreamId }) {
  return (
    <ModalUI show={show} handleClose={handleClose} title="Add New Lesson">
      <AddNewLessonForm
        handleClose={handleClose}
        onAddLesson={onAddLesson}
        taskId={taskId}
        workStreamId={workStreamId} // pass workStream_Id if needed
      />
    </ModalUI>
  );
}


function AddNewLessonForm({ handleClose, taskId, onAddLesson, workStreamId }) {
  const [taskList, setTaskList] = useState([]);
  const { data: organization } = useContext(OrganizationContext);
  const [showAddTemplateModal, setShowAddTemplateModal] = useState(false);
  const [showSelectTemplateModal, setShowSelectTemplateModal] = useState(false);

  // Fetch all tasks of the organization
  useEffect(() => {
    getTasks({ organization_id: organization.current_organization.id, workStream_id: workStreamId })
      .then((response) => {
        if (response.status === 200) {
          const tasks = response.data.map((task) => ({
            ...task,
            id: task.id,
            name: task.title,
          }));
          setTaskList(tasks);
        }
      })
      .catch((error) => {
        showToast("Failed to fetch tasks", "error");
        console.error(error);
      });
  }, [organization.current_organization.id]);

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      title: "",
      task_id: taskId ? taskId : "" || null,
      description: "",
    },
    validationSchema: lessonValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const lessonPayload = {
        title: values.title,
        task_id: values.task_id,
        description: values.description,
      };

      createLesson(lessonPayload)
        .then((response) => {
          if (response.status === 201) {
            showToast("Lesson added successfully", "success");
            if (onAddLesson && typeof onAddLesson === "function") {
              onAddLesson(response.data);
            }
            handleClose();
          }
        })
        .catch((error) => {
          showToast("Failed to add lesson", "error");
          console.error(error);
        })
        .finally(() => setSubmitting(false));
    },
  });

      const dropdownItems = [
    {
      label: 'Use a template',
      onClick: () => setShowSelectTemplateModal(true),
    },
    {
      label: 'Save as template',
      onClick: () => setShowAddTemplateModal(true),
    },
  ];


  return (
    <form onSubmit={formik.handleSubmit}>
      {/* Title Field with ShortTextInput */}
      <ShortTextInput
        label="Title"
        id="title"
        value={formik.values.title}
        onChange={formik.handleChange}
        placeholder="Enter title"
        error={formik.touched.title && formik.errors.title}
        helperText={formik.touched.title ? formik.errors.title : ""}
        fullWidth
        required
      />

      {/* Task Selection with CustomSelectBox */}
      {!taskId && (
        <CustomSelectBox
          label="Goal"
          id="task_id"
          value={formik.values.task_id || ""}
          onChange={(e) => formik.setFieldValue("task_id", e.target.value)}
          options={taskList.map((task) => ({
            value: task.id,
            label: task.title,
          }))}
          error={formik.touched.task_id && formik.errors.task_id}
          helperText={formik.touched.task_id ? formik.errors.task_id : ""}
          fullWidth
          required
        />
      )}

      <div className="position-relative ">
        <div className="position-absolute end-0 top-0 m-1">
        <CustomTemplateDropdown icon={ HiOutlineDotsHorizontal}  items={dropdownItems}/>
        </div>
        <RichTextEditor
          label="Description"
          id="description"
          placeholder="Enter Risk description..."
          required
          editorValue={formik.values.description} 
          setEditorValue={(value) => formik.setFieldValue("description", value)}
          error={formik.touched.description && formik.errors.description}
        />
       </div>

       {showSelectTemplateModal && (
        <SelectLessonTemplateModal
          show={showSelectTemplateModal}
          handleClose={() => setShowSelectTemplateModal(false)}
          refresh={() => {}}
          handleUse={(template) => {
            formik.setFieldValue("description", template.description);
            setShowSelectTemplateModal(false);
          }}
          
        />
      )}

      {showAddTemplateModal && (
        <AddUpdateLessonTemplateModal
          show={showAddTemplateModal}
          handleClose={() => setShowAddTemplateModal(false)}
          refresh={() => {}}
          defaultDescription={formik.values.description}

        />
      )}


      {/* Action Buttons */}
      <div className="d-flex align-items-center justify-content-center mt-3">
        <CustomButton type="submit" disabled={formik.isSubmitting}>
          {formik.isSubmitting ? "Adding..." : "Add"}
        </CustomButton>
      </div>
    </form>
  );
}

export default AddNewLesson;
